import React, {useContext, useState,useEffect} from 'react';
import { Form, Input, Button, Alert } from 'antd';
import axios from 'axios'
import {SideContext} from "../contexts/SideContext";
import {Redirect} from "react-router-dom";
import {CubeContext} from "../contexts/CubeContext";
import {RoleContext} from "../contexts/RoleContext";
import {LoginContext} from "../contexts/LoginContext";

const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 16,
    },
};

const btnLayout = {
    wrapperCol: {
        offset: 13,
        span: 16,
    },
};

const alertLayout = {
    wrapperCol: {
        offset: 8,
        span: 22
    }
}

const SignIn = ({imba_id}) => {
    
    const [authFail, setAuthFail] = useState(true);
    const [success, setSuccess] = useState(false);
    const {getSideKey} = useContext(SideContext);
    const {setCubeToken} = useContext(CubeContext);
    const {setRole} = useContext(RoleContext);
    const [pathname, setPathname] = useState('');
    const {setLogin} = useContext(LoginContext);
    localStorage.removeItem('get-token-cube');

    const onFinish = (values) => {
        axios.post(
            `https://api.imbachat.com/imbachat/v1/widget/imba_login/${imba_id}`,
            values,
            {
                headers: {
                    //"Access-Control-Allow-Origin": "*",
                }
            }
        ).then((response) => {
            let data = response.data
            let login =document.querySelector("#basic_login").value;
            localStorage.setItem('imbachat_login', login);
            setLogin(login);
            if (data.auth) {
                localStorage.setItem('comet-token', data.token);
                localStorage.setItem('comet-user-id', data.user_id);
                localStorage.setItem('cube-token', data.cubeJWT);
                localStorage.setItem('role', data.role);
                let key = getSideKey();
                /*switch (key) {
                    case 0:
                    case 1:
                        setPathname(`/${imba_id}`)
                        break;
                    case 2:
                        //setPathname(`/${imba_id}/users`)
                        setPathname(`/${imba_id}`)
                        break;
                    case 3:
                        //setPathname(`/${imba_id}/messages`)
                        setPathname(`/${imba_id}`)
                        break;
                    case 4:
                        //setPathname(`/${imba_id}/rooms`)
                        setPathname(`/${imba_id}`)
                        break;
                }*/
                setPathname(`/${imba_id}`)
                setCubeToken(data.cubeJWT)
                setRole(data.role)
                setSuccess(true)
            } else {
                setAuthFail(false)
            }
        }).catch((error) => {

        })
    };

    const onFinishFailed = (errorInfo) => {

    };
    useEffect(() => {
        let interval = setInterval(()=>{
            //if(window.imbaChat) window.imbaChat.destroy()
            //console.log('ss')
            if(!window.location.hash.includes('signIn')) return;
            
            if(document.querySelector('#imbachat'))  {
                
                setTimeout(()=> {
                    document.querySelector("#imbachat").style.display = 'none'
                },10000)
                document.querySelector("#imbachat").style.display = 'none'
            }
        },100)
      }, [])
    return success ? (
        <Redirect to = {{ pathname: pathname }} />
    ) : (
        <Form
            {...layout}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
        >
            <Form.Item
                label="login"
                name="login"
                rules={[
                    {
                        required: true,
                        message: 'Please input your login!',
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Password"
                name="password"
                rules={[
                    {
                        required: true,
                        message: 'Please input your password!',
                    },
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item {...btnLayout}>
                <button className={'button'} type={'submit'}>Submit</button>
            </Form.Item>
            <Form.Item {...alertLayout} hidden={authFail}>
                <Alert
                    message="Wrong credentials"
                    type="error"
                    showIcon
                />
            </Form.Item>
        </Form>
    );
};

export default SignIn;
